export default "assets/images/logo-footer-f89f6de7.png";